import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import "./Components/services/i18n";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

root.render(<App />);
